const Biblequizpage = () => {
    return (
        <div className="biblequizpage">
            <h2>This current Page is under development... Check back later</h2>
        </div>
      );
}
 
export default Biblequizpage;